import React, { useState, useEffect } from "react";
import {useHistory} from "react-router";
import style from "./menu.scss";
import Layout from "@/layout/Layout";
import {getCardList} from "@/api/card";

const Setting = () => {
  const history = useHistory()
  const [hasExchangeableCard, setHasExchangeableCard] = useState(false)

  useEffect(() => {
    (async () => {
      const cards = await getCardList()
      // Check if at least one card has canExchange property
      const hasExchangeable = cards.some(card => card.canExchange)
      setHasExchangeableCard(hasExchangeable)
    })()
  }, [])

  const toProfile = () => {
    history.push('/profile')
  }

  const toHomePage = () => {
    history.push('/homePage')
  }

  const toChangePassword = () => {
    history.push('/changePassword')
  }

  const goBack = () => {
    history.push('/menu')
  }

  return (
    <div className="App">
      <Layout needTopBar={false}>
        <div className={style.buttons}>
          <button className={style.menuButton} type="button" onClick={toProfile}>プロフィール</button>
          {hasExchangeableCard && (
            <button className={style.menuButton} type="button" onClick={toHomePage}>ホームページ</button>
          )}
          <button className={style.menuButton} type="button" onClick={toChangePassword}>パスワード変更</button>
          <button className={style.menuButton} type="button" onClick={goBack}>戻る</button>
        </div>
      </Layout>
    </div>
  )
}

export default Setting;
